<template>
	<app-select
		:placeholder="$t('city')"
		:can-deselect="false"
		:options="cities"
		@update:model-value="onValChange"
		@select="$emit('update:modelValue', $event)"
	/>
</template>

<script>
	import AppSelect from '@/components/app/AppSelect';
	import { mapGetters } from 'vuex';
	import { prepAutocompleteData } from '@/services/UtilityService';

	export default {
		name: 'AppCitySelect',
		emits: ['update:model-value'],
		components: { AppSelect },
		computed: {
			...mapGetters({
				allCities: 'allCities',
			}),
			cities() {
				return [{ value: -1, label: 'All' }, ...prepAutocompleteData(this.allCities, 'description', 'id')];
			},
		},
		methods: {
			onValChange() {},
		},
	};
</script>

<style scoped></style>
